import {
    Button,
    Drawer,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import { PageRequest } from "api/sharedModels/PageRequest";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PopupNotification } from "components/PopupNotification/PopupNotification";
import ThorPagination from "components/ThorPagination/ThorPagination";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useStore } from "store/StoreConfigs";
import AddUserForm from "./AddUserForm";
import { userManagementStyles } from "./userManagementStyles";

export default observer(function UsersTab() {
    const classes = userManagementStyles();
    const { userStore, identityStore } = useStore();
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const request: PageRequest = {
            pageNumber: userStore.currentPage,
            pageSize: 5,
            customerId: identityStore.currentCustomerId,
        };

        userStore.loadUsers(request);
    }, [userStore.currentPage]);

    const closeDrawer = () => setDrawerOpen(false);
    const openDrawer = () => setDrawerOpen(true);

    const successCallback = (email: string) => {
        let id: string | number = "";

        const handlePopupClose = () => {
            toast.dismiss(id);
        };

        closeDrawer();

        id = toast(
            <PopupNotification
                type="success"
                title={`User '${email}' added successfully`}
                closeCallback={handlePopupClose}
            />
        );
    };

    if (userStore.areUsersLoading) {
        return (
            <div style={{ maxHeight: "300px", maxWidth: "300px" }}>
                <LoadingIndicator />
            </div>
        );
    }

    return (
        <div>
            <Button className={classes.addButton} onClick={openDrawer}>
                Add User
            </Button>

            {drawerOpen && (
                <>
                    <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer}>
                        <AddUserForm successCallback={successCallback} />
                    </Drawer>
                </>
            )}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Customer</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>First Name</TableCell>
                            <TableCell>Last Name</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userStore.users.map((user) => (
                            <TableRow key={user.id}>
                                <TableCell>{user.id}</TableCell>
                                <TableCell>{user.customerName}</TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.firstName}</TableCell>
                                <TableCell>{user.lastName}</TableCell>
                                <TableCell>
                                    <Button>Edit</Button>
                                    <Button>Delete</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ThorPagination
                page={userStore.currentPage}
                pages={userStore.totalPages}
                onPageChange={userStore.movePage}
                isLastPage={userStore.isLastPage}
                setPage={userStore.setPage}
            />
        </div>
    );
});
